import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { InvoiceStatus } from './InvoiceStatus';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 12px auto 0;
  width: 100%;
  max-width: 750px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
  background-color: white;
  border-radius: 12px;
  border: black 1px solid;
`

const STATE = {};

class RelatedInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  get invoiceId() {
    return this.invoice.id;
  }

  get isFinal() {
    return this.invoice.isFinal ? 'FINAL' : 'NOT FINAL';
  }

  get invoiceStatus() {
    return this.invoice.status?.name ?? 'OPEN';
  }

  get subjectType() {
    return this.invoice.subjectType?.toUpperCase();
  }

  get type() {
    return this.invoice.type?.toUpperCase() ?? 'INVOICE';
  }

  onClick() {
    this.props.onClick(`/invoices/${this.invoiceId}`);
  }

  get description() {
    return this.props.invoice.description;
  }

  render() {
    return this.invoice && (
      <Wrapper key={this.invoiceId}  onClick={this.onClick.bind(this)}>
        <HBox vCenter>
          <div style={{ fontWeight: 'bold'}}>
            <span style={{ width: '40px', marginRight: 10 }}>{this.invoiceId}</span>
            <span>{this.description ?? '-'}</span>
          </div>
        </HBox>
        <HBox vCenter left style={{ gap: 10, flexWrap: 'wrap'}}>
          { this.type && <InvoiceStatus status={this.type}/> }
          { this.subjectType && <InvoiceStatus status={this.subjectType} />}
          <InvoiceStatus status={this.invoiceStatus} />
          <InvoiceStatus status={this.isFinal} />
        </HBox>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const RelatedInvoiceCard = compose(
  withConnect,
  withRouter,
)(RelatedInvoiceCardComp);
